import { cloudFunction } from 'services/parse';

export const fetchPaginatedAccounts = (data: Record<string, any>) => {
  return cloudFunction('fetchPaginatedAccounts', data);
};

export const fetchAccountDetails = (id: string) => {
  return cloudFunction('fetchAccountDetails', { id });
};

export const sendPendingPaymentEmailToAccount = (id: string) => {
  return cloudFunction('sendPendingPaymentEmailToAccount', { id });
};

export const createAccount = (data: Record<string, any>) => {
  return cloudFunction('createAccount', data);
};

export const updateAccount = (data: Record<string, any>) => {
  return cloudFunction('updateAccount', data);
};

export const addUserToAccount = (userId: string, accountId: string) => {
  return cloudFunction('addUserToAccount', { userId, accountId });
};

export const removeUserFromAccount = (userId: string) => {
  return cloudFunction('removeUserFromAccount', { userId });
};

export const searchAccountByName = (data: Record<string, any>) => {
  return cloudFunction('searchAccountByName', data);
};